import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FleetTrackingQuotesWrapper from "@components/layouts/fleetTrackingQuotesWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <FleetTrackingQuotesWrapper>
            <TermsAndConditions
                category="Fleet Trackers"
                domain="FleetTrackingQuotes.com"
            />
        </FleetTrackingQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
